import React from 'react';
import styles from './RemoveConfirmation.module.scss';
import Button from '../Button';
import LinkButton from '../Button/LinkButton/LinkButton';
import Text from '../Text';

interface Props {
	onConfirm: () => void;
	onAbort: () => void;
	confirmationText?: string;
}

const RemoveConfirmation: React.FC<Props> = ({
	onConfirm,
	onAbort,
	confirmationText = 'base.deleteConfirmationDefaultText',
}) => {
	return (
		<>
			<Text tx={confirmationText} />
			<div className={styles.controls}>
				<Button onClick={onAbort} text='base.no' firstUpper />
				<LinkButton
					onClick={onConfirm}
					text='base.yes'
					theme='purple'
					firstUpper
				/>
			</div>
		</>
	);
};

export default RemoveConfirmation;
